import usePrice from '@commerce/product/use-price'
import type { ProductVariant } from '@commerce/types/product'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'

const ProductCartButtonText: FC<{
  variant?: ProductVariant
  currencyCode?: string
  productUnavailable?: boolean
}> = ({ variant, currencyCode = 'AUD', productUnavailable }) => {
  const { t } = useTranslation('common')
  const price = usePrice({
    amount: variant?.price!,
    currencyCode,
    suffix: `${t('vat-as-applicable')}`,
  })
  const { locale } = useRouter()

  if (productUnavailable) {
    return <div>{`${t('unavailable')}`}</div>
  }

  if (!variant) {
    return <div>{`${t('make-your-selection')}`}</div>
  }

  if (!variant.availableForSale) {
    return <div>Out of Stock</div>
  }

  return (
    <div>
      {`${t('add-to-cart')} - ${price.price} ${
        locale === 'en-gb' ? `(incl. GST / VAT)` : ''
      }`}
    </div>
  )
}

export default ProductCartButtonText
